module.exports = __webpack_public_path__ + "img/inter-milan-logo-icon.6dc9a775.png";